import { IFormItem } from '@components/Form/FormItem/FormItem';
import { ITableColumn } from '@components/common/UTable/UTable';
import { MODULE_TYPE } from '@/shared/roles/enums';

export const roleFormSchema: IFormItem[] = [
  {
    label: 'Название',
    key: 'description',
    type: 'text',
    disabled: true,
  },
  {
    label: 'Описание',
    key: 'detailedDescription',
    type: 'textarea',
    disabled: true,
  },
];
export const permissionsTableColumns: ITableColumn[] = [
  {
    title: '№ п/п',
    dataIndex: 'index',
    width: 50,
  },
  {
    title: 'Наименование права',
    dataIndex: 'description',
  },
  {
    title: 'Описание',
    dataIndex: 'detailedDescription',
    width: 300,
  },
  {
    title: 'Модуль',
    dataIndex: 'module',
    render: (value: string) => MODULE_TYPE[value as keyof typeof MODULE_TYPE],
  },
];
